package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.appscrud.add.AppsAddPage
import org.moxultimate.topwithmox.components.layouts.PageLayoutData

@InitRoute
fun initAppsAddRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Add App"))
}

@Page(routeOverride = "appsadd")
@Layout(".components.layouts.PageLayout")
@Composable
fun AppsAddRoute() {
    AppsAddPage()
}
